import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 14.624 11.25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.062 0H.562A.56.56 0 0 0 0 .563v9.562a1.12 1.12 0 0 0 1.124 1.125H13.5a1.125 1.125 0 0 0 1.124-1.125V.563A.56.56 0 0 0 14.062 0M1.124 4.5h2.813v2.25H1.124zm3.938 0H13.5v2.25H5.062zM13.5 1.125v2.25H1.124v-2.25zM1.124 7.875h2.813v2.25H1.124zm12.376 2.25H5.062v-2.25H13.5z"
    }, null, -1)
  ])))
}
export default { render: render }